import React from 'react';
import { testimonials } from '../data/piano';
export function Testimonials() {
  // Hidden until authentic PIANO READY reviews are added in data/piano.ts
  if (testimonials.length === 0) return null;
  return <section className="w-full border-t border-slate-900/10 bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-286" data-mp="3fyvx076lj79i">
      <div className="mx-auto max-w-6xl" data-id="element-287" data-mp="3azjcht376ca3">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-288" data-mp="3ayhz3hypldp7">
          What <em className="text-red-700" data-id="element-289" data-mp="36wmrjvq6q42z">teachers</em> say
        </h2>

        <div className="mt-14 grid gap-10 border-t border-slate-900/15 pt-10 sm:grid-cols-3" data-id="element-290" data-mp="31ybhpkzw3tkr">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col" data-id="element-291" data-mp="2x2mnzyajx6wd">
              <div className="text-sm text-amber-500" aria-label="5 out of 5 stars" data-id="element-292" data-mp="2s39p2f6eo9df">
                <span aria-hidden="true" data-id="element-293" data-mp="v8589t0m550o">★★★★★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-serif text-2xl leading-snug text-slate-900" data-id="element-294" data-mp="q9tzllm210k1">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-6 text-sm" data-id="element-295" data-mp="h817no7u2gkh">
                <span className="font-semibold text-slate-900" data-id="element-296" data-mp="m5b43ntn3sht">{item.name}</span>
                <span className="text-slate-900/60" data-id="element-297" data-mp="780kfr6ufgb0"> — {item.location}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}